<div class="section-list expandable-list"
     [id]="'expandable-list-' + listId"
     [ngClass]="{'border-bottom ms-bclb-g40': listModel?.items?.length && isTileOrCardView, 'expandable-list-refresh': isVisualRefresh}"
     [@fadeInOut]="currentState()" (@fadeInOut.done)="onAnimationCompleted($event)">
    <div *ngIf="listModel?.items?.length"
         [ngClass]="{'section-list__table ms-Grid': !isTileOrCardView && !isListColView,
         'generic-tile-container': isTileOrCardView && listModel.items.length,
         'generic-tile-container--fluent': isTileView && fluentRefresh,
         'generic-tile-container--doc-tile': isTileView,
         'generic-tile-container--card': isCardView,
         'generic-row-container--row': isListColView,
         'generic-tile-container--card--small': isSmallMobileCards}">
        <div class="expandable-list__item"
             *ngFor="let item of listModel.items | slice:0:getDisplayedItemCount(); let i = index; trackBy: trackById"
             [ngClass]="{'expandable-list__item--bordered': !isTileOrCardView && !isListColView && i !== 0,
             'list-item--shadowed ms-bgc-w-h': !isTileOrCardView && !mobileMenusEnabled && !fluentRefresh,
             'list-item--fluent': !isTileOrCardView && fluentRefresh,
             'expandable-list-col__item expandable-list-col__item--bordered': isListColView,
             'ms-bclt-g40': i !== 0,
             'ms-bclt-g50': i === 0,
             'ms-bclb-g40': i === getDisplayedItemCount() - 1}"
             [class.expandable-list__item--tile]="isTileOrCardView"
             [class.list-item--tile--even-padding]="isEvenPadding"
             [class.ms-Grid-row]="!isTileOrCardView && !isListColView">
            <ng-template [ngTemplateOutlet]="listItemTemplate"
                         [ngTemplateOutletContext]="{
                        item: item,
                        index: i,
                        itemView: itemView,
                        focusOnLoad: shouldFocusOnLoad(i)}">
            </ng-template>
        </div>
    </div>
</div>
<ohp-title-announcer [announcement]="updateAnnouncement"></ohp-title-announcer>
<button *ngIf="listModel?.showMoreVisible(isTileOrCardView || isListColView)"
   [id]="seeMoreLinkId"
   class="see-more-items ms-fcl-ns"
   (keydown)="toggleShowMoreKeyboard($event)"
   (click)="toggleShowMore()"
   [attr.aria-label]="isListOpen ? (listModel.showLessAriaLabel || showLessButtonAriaLabelDefault) : (listModel.showMoreAriaLabel || showMoreButtonAriaLabelDefault)"
   role="button"
   data-clicklog="custom">
    <div class="flex-container">
        <div *ngIf='listModel.options?.infiniteShowMoreEnabled && listModel.infiniteShowMoreEnabledAndVisible(isTileOrCardView)'>
            <span>{{ listModel.options?.showMoreText || showMoreButtonTextDefault }}</span>
            <ohp-icon-font iconFontName="ChevronDown"
                           cssClass="see-more-items__icon--fluent"
                           [size]="8">
            </ohp-icon-font>
        </div>
        <div *ngIf='!listModel.options?.infiniteShowMoreEnabled'>
            <span>{{ isListOpen ? (listModel.options?.showLessText || showLessButtonTextDefault) : (listModel.options?.showMoreText || showMoreButtonTextDefault) }}</span>
            <ohp-icon-font [iconFontName]="isListOpen ? 'ChevronUp' : 'ChevronDown'"
                            cssClass="see-more-items__icon--fluent"
                            [size]="8">
            </ohp-icon-font>
        </div>
    </div>
</button>
